module.exports = __webpack_public_path__ + "img/check_circle.314d0802.svg";